// Formats a number to a float with 2 decimal places
export default function(price) {
	if (price === null || price === undefined) return '';
	return price
		.toFixed(2)
		.toString()
		.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
}
